"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNameInitials = void 0;
/**
 * Extracts the initials from a given name string.
 * This function helps avoid storing user PII
 * in observability tools by converting names into their initials.
 *
 * @param {string} name - The name string from which to extract initials.
 * @returns {string} The initials of the name in uppercase, separated by spaces,
 * or an empty string if the input is invalid.
 */
var getNameInitials = exports.getNameInitials = function getNameInitials(name) {
  if (!name || typeof name !== 'string') {
    return '';
  }
  return name.split(' ').filter(function (word) {
    return word.trim().length > 0;
  }).map(function (word) {
    return word[0].toUpperCase();
  }).join(' ');
};